import { useEffect } from "react";

const TaboolaScript = ({ page = "article", isMobile=false }) => {
  useEffect(() => {
    let loaded = false;

    const registerWidget = () => {
      window._taboola = window._taboola || [];
      window._taboola.push({
        mode: "thumbnails-below",
        container: `taboola-below-${page}-thumbnails-${isMobile?"mobile":"desktop"}`,
        placement: `Below ${page=="article"?"Article":page=="video"?"Video":page=="photo"?"Photo":"Home"} Thumbnails ${isMobile?"Mobile":"Desktop"}`,
        target_type: "mix",
      });
    };
    
    const flushOnce = () => {
      if (window.__taboolaFlushed) return;
      window.__taboolaFlushed = true;

      window._taboola = window._taboola || [];
      window._taboola.push({ flush: true });
    };

    const markTaboolaInit = () => {
      if (window.performance && typeof window.performance.mark === "function") {
        window.performance.mark("tbl_ic");
      }
    };

    const onScroll = () => {
      if (loaded || window.scrollY <= 200) return;
      loaded = true;

      window._taboola = window._taboola || [];
      if (page == "article") {
        window._taboola.push({ article: "auto" });
      }
      if (page == "video") {
        window._taboola.push({ video: "auto" });
      }
      if (page == "photo") {
        window._taboola.push({ photo: "auto" });
      }
      if (page == "home") {
        window._taboola.push({ homepage: "auto" });
      }
      

      if (!document.getElementById("tb_loader_script")) {
        const s = document.createElement("script");
        s.async = true;
        s.id = "tb_loader_script";
        s.src =
          "//cdn.taboola.com/libtrc/indiatoday-newstak/loader.js";

        s.onload = () => {
          markTaboolaInit();
          registerWidget(); 
          flushOnce();
        };

        document.head.appendChild(s);
      }

      window.removeEventListener("scroll", onScroll);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return null;
};

export default TaboolaScript;
